export default __webpack_public_path__ + "static/media/02.26.25 Minutes Reg Mtg.b0557484.pdf";